import useInView from '../../../hooks/useInView';

interface Step {
  icon: string;
  title: string;
  desc: string;
}

interface ProcessStepsProps {
  steps: Step[];
}

const ProcessSteps = ({ steps }: ProcessStepsProps) => {
  const { ref, inView } = useInView({ threshold: 0.15 });

  return (
    <section className="py-16 md:py-20 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="text-center mb-12 transition-all duration-700"
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(20px)' }}
        >
          <p className="text-[#C41E3A] text-xs font-bold uppercase tracking-widest mb-2">Our Process</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#111827]">How It Works</h2>
          <p className="text-[#6B7280] mt-3 max-w-lg mx-auto text-sm sm:text-base">
            From first call to final walkthrough — here&apos;s exactly what to expect when you work with Renova.
          </p>
        </div>

        <div className="relative">
          {/* Desktop connecting line */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-[#E2E8F0] z-0" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, i) => (
              <div
                key={step.title}
                className="flex flex-col items-center text-center transition-all duration-700"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(28px)',
                  transitionDelay: `${i * 120}ms`,
                }}
              >
                <div className="relative mb-5">
                  <div className="w-20 h-20 rounded-full bg-white border-2 border-[#E2E8F0] flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-[#C41E3A]`} />
                  </div>
                  <div className="absolute -top-1 -right-1 w-6 h-6 bg-[#C41E3A] rounded-full flex items-center justify-center">
                    <span className="text-white text-xs font-bold">{i + 1}</span>
                  </div>
                </div>
                <h3 className="text-sm font-bold text-[#111827] mb-2">{step.title}</h3>
                <p className="text-sm text-[#6B7280] leading-relaxed max-w-[180px]">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
